<form nz-form [formGroup]="form" theme>
  <div class="row">
    <nz-alert
      class="mb-4"
      nzType="warning"
      nzMessage="Para agilizar seu cadastro, buscaremos dados complementares no site da Receita Federal.
  Este é um procedimento seguro e o sigilo dos seus dados é garantido pela nossa plataforma"
    ></nz-alert>
  </div>
  <app-pet-data-form
    [form]="form"
    [isResponsible]="isResponsible"
    [fullnameResponsible]="fullnameResponsible?.value"
    (patchFormEvent)="patchFormResponsible($event)"
    (changeConsultResponsibleEvent)="consultResponsible = $event"
  ></app-pet-data-form>
  <app-personal-data-form
    *ngIf="isResponsible || consultResponsible"
    [form]="formResponsible"
    [isResponsible]="isResponsible || consultResponsible"
    [isPet]="'true'"
  ></app-personal-data-form>
  <app-contacts-data-form
    [form]="formResponsible"
    [isPet]="'true'"
    *ngIf="isResponsible || consultResponsible"
  ></app-contacts-data-form>
  <app-address-data-form
    [form]="formResponsible.get('address')"
    [isPet]="'true'"
    *ngIf="isResponsible || consultResponsible"
  ></app-address-data-form>
</form>
